//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CoffeeIcon, BriefcaseIcon } from 'vue-feather-icons'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'SignUpRoles',
  components: {
    CoffeeIcon,
    BriefcaseIcon
  },
  computed: {
    query () {
      return this.$route.query.referrer ? { referrer: this.$route.query.referrer } : {}
    }
  }
}
